import styled from "styled-components";

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Profile = styled.div`
  text-align: center;
`;

export const MainProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  input {
    display: none;
  }
`;

export const MainProfileImgLayout = styled.div`
  position: relative;
`;

export const MainProfileImgCameraBox = styled.div`
  width: 40%;
  height: 40%;
  display: flex;
  align-items: center;
  position: absolute;
  background: ${(props) => props.theme.colors.gray};
  border-radius: 100%;
  border: 3px solid ${(props) => props.theme.colors.white};
  padding: 6px;
  bottom: 0;
  right: -6px;
`;

export const MainProfileBox = styled.div`
  width: 96px;
  height: 96px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadow.box};
  border-radius: 100%;
  padding: 6px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

export const ProfileTxtBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const UserAuthSpan = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.4rem;
  font-weight: 600;
`;

export const UserStatusBox = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const UserNameText = styled.p`
  font-size: 2.4rem;
  font-weight: 600;
`;

export const UserInfoEditButtonBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  right: 20px;
  gap: 3px;

  p {
    font-size: 1.6rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
  }
`;
